export const NAMESPACE = "CallForPapersForm";

export const WELCOME_COLORS = {
  0: "indigo7",
  1: "gray7",
  2: "gray7",
  3: "gray7"
};

export const LOGIN_COLORS = {
  0: "gray7",
  1: "indigo7",
  2: "gray7",
  3: "gray7"
};

export const GROUP_COLORS = {
  0: "gray7",
  1: "gray7",
  2: "indigo7",
  3: "gray7"
};

export const CONTACT_COLORS = {
  0: "gray7",
  1: "gray7",
  2: "gray7",
  3: "indigo7"
};

export const MAX_SPEAKERS = 10;

export const MODULES_TINY_MCE =
  "table media link code lists image codesample eqneditor wordcount";
export const FORMATS_TINY_MCE =
  "bold italic underline | superscript subscript link eqneditor | bullist numlist outdent indent | image | removeformat | code | codesample";
